import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import {
  emailValidator,
  MobileNoIntValidator,
  requiredValidator,
} from "../../../components/formFields/CommonValidator";
import FormTextField from "../../../components/formFields/FormTextField";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import RippleButton from "../../../components/common/RippleButton";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import {
  createQuotationStep1,
  getAllHotelsForDropdown,
  getQuotationByID,
  updateQuotationStep1,
} from "../services/quotation.services";
import {
  clearQuotationInformation,
  increaseActiveStep,
} from "../quotationSlice";
import ShadowCard from "../../../components/common/ShadowCard";
import FormNumericTextField from "../../../components/formFields/FormNumericTextField";
import FormDatePicker from "../../../components/formFields/FormDateField";
import moment from "moment";
import QuotationAccomodationArray from "./QuotationAccomodationArray";
import { getAllActiveRoomTypes } from "../../roomtype/services/roomType.services";
import { getAllActiveMealTypes } from "../../mealtype/services/mealtype.services";
import QuotationMiscellaneousArray from "./QuotationMiscellaneousArray";
import QuotationTransportArray from "./QuotationTransportArray";
import { getAllActiveVehicleTypes } from "../../vehicletype/services/vehicletype.services";
import { getInquiryByID } from "../../inquiry/services/inquiry.services";
import {
  getContactByID,
  insertContactFromOtherPlace,
} from "../../contact/services/contact.services";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import { ILeadSource } from "../../leadsource/leadsourceModel";
import { NAMEPREFIX, SECTORTYPE } from "../../../_contstants/common";
import { getAllActiveLeadSource } from "../../leadsource/services/leadsource.service";
import {
  getAllActiveSectors,
  getSectorByID,
} from "../../sector/services/sector.services";
import { ISector } from "../../sector/sectorModel";
import { ICompany } from "../../company/companyModel";
import { getAllActiveCompanies } from "../../company/services/company.services";
import FormCheckbox from "../../../components/formFields/FormCheckbox";
import {
  getAllActiveHotelRoomCategory,
  getHotelSpecialRate,
} from "../../hotel/services/hotel.services";
import { clearInquiryDetails } from "../../inquiry/inquirySlice";
import { getAllActiveFoodOptions } from "../../foodoption/services/foodOption.services";
import { IFoodOption } from "../../foodoption/foodOptionModel";
import { LoadingPanel } from "../../../components/layout/Loading";
import { getLeadByID } from "../../lead/services/lead.services";
import { clearLeadDetails } from "../../lead/leadSlice";
import { clearContactDetails } from "../../contact/contactSlice";
import { getAdminSettings } from "../../adminsetting/services/adminsetting.services";
import { getAllActiveCurrencies } from "../../currency/services/currency.services";
import { Button } from "@progress/kendo-react-buttons";
import QuotationSightseenArray from "./QuotationSightseenArray";
import { getSightseensBySectorID } from "../../sightseen/services/sightseen.services";
import { Label } from "@progress/kendo-react-labels";
import { openDialog } from "../../../components/dialog/dialogSlice";
import AppDialog from "../../../components/dialog/Dialog";
import TravellerQuotationRoomArray from "./TravellerQuotationRoomArray";
import FormRichTextField from "../../../components/formFields/FormRichTextField";
import { clearHotelRateDetails } from "../../hotel/hotelSlice";

interface ChangeWatcherProps {
  formRenderProps: FormRenderProps;
}

const SectorChangeWatcher: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const SectorList = useAppSelector((state) => state.sector.SectorList);
  const isCityRef = useRef(true);
  const SectorID = formRenderProps.valueGetter("SectorID");
  const location = useLocation();
  const dispatch = useAppDispatch();
  const QuotationID = location.state?.QuotationID;

  const handleTermsNCondition = async (SectorID: any) => {
    try {
      const isEmpty = formRenderProps.valueGetter("TermsNCondition");
      if (isEmpty === "" || isEmpty === "<br>") {
        const result: any = await dispatch(getSectorByID(SectorID));
        if (result?.meta?.requestStatus === "fulfilled") {
          formRenderProps.onChange("TermsNCondition", {
            value: result.payload.TermsNCondition,
          });
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  useEffect(() => {
    if (SectorID) {
      handleTermsNCondition(SectorID);
      dispatch(getSightseensBySectorID(SectorID));
      const currentSector = SectorList?.find((sector: ISector) => {
        return sector?.ID === +SectorID;
      });
      if (!isCityRef.current) {
        if (currentSector?.SectorType) {
          formRenderProps.onChange("Type", {
            value: currentSector?.SectorType,
          });
        }
      } else {
        if (!QuotationID) {
          if (currentSector?.SectorType) {
            formRenderProps.onChange("Type", {
              value: currentSector?.SectorType,
            });
          }
        }
        isCityRef.current = false;
      }
    }
  }, [SectorID]);

  return null;
};

const TotalChangeWatcher: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const AdminSettingDetails = useAppSelector(
    (state) => state.adminsetting.AdminSettingDetails,
  );

  const Transportations = formRenderProps.valueGetter("Transportations");
  const Miscellaneous = formRenderProps.valueGetter("Miscellaneous");
  const SightSeen = formRenderProps.valueGetter("SightSeen");
  const TotalAccommodationRate =
    formRenderProps.valueGetter("TotalAccommodationRate") || 0;
  const AccommodationConversionRate =
    formRenderProps.valueGetter("AccommodationConversionRate") || 1;
  const convertedTotalAccommodationRate =
    formRenderProps.valueGetter("convertedTotalAccommodationRate") || 0;

  const TotalTransportation = formRenderProps.valueGetter(
    "TotalTransportation",
  );
  const TransportaionConversionRate =
    formRenderProps.valueGetter("TransportaionConversionRate") || 1;
  const convertedTotalTransportation =
    formRenderProps.valueGetter("convertedTotalTransportation") || 0;
  const TotalMiscellaneous =
    formRenderProps.valueGetter("TotalMiscellaneous") || 0;
  const TotalSightSeen = formRenderProps.valueGetter("TotalSightSeen") || 0;
  const MiscellaneousConversionRate =
    formRenderProps.valueGetter("MiscellaneousConversionRate") || 1;
  const SightSeenConversionRate =
    formRenderProps.valueGetter("SightSeenConversionRate") || 1;
  const convertedTotalMiscellaneous =
    formRenderProps.valueGetter("convertedTotalMiscellaneous") || 0;
  const convertedTotalSightSeen =
    formRenderProps.valueGetter("convertedTotalSightSeen") || 0;

  const DriverAllowance = formRenderProps.valueGetter("DriverAllowance") || 0;
  const TotalTax = formRenderProps.valueGetter("TotalTax") || 0;
  const AccommodationMarkup =
    formRenderProps.valueGetter("AccommodationMarkup") || 0;
  const TransportMarkup = formRenderProps.valueGetter("TransportMarkup") || 0;
  const MiscellaneousMarkup =
    formRenderProps.valueGetter("MiscellaneousMarkup") || 0;
  const SightSeenMarkup = formRenderProps.valueGetter("SightSeenMarkup") || 0;

  const TotalMarkup = formRenderProps.valueGetter("TotalMarkup") || 0;
  const TotalAmount = formRenderProps.valueGetter("TotalAmount") || 0;
  const SubTotalAmount = formRenderProps.valueGetter("SubTotalAmount") || 0;
  const DiscountAmt = formRenderProps.valueGetter("DiscountAmt") || 0;
  const GstValue = formRenderProps.valueGetter("GstValue") || 0;
  const GstPer = formRenderProps.valueGetter("GstPer") || 0;
  const TCS = formRenderProps.valueGetter("TCS") || 0;
  const isTCS = formRenderProps.valueGetter("isTCS");
  const Type = formRenderProps.valueGetter("Type");
  const Accommodations = formRenderProps.valueGetter("Accommodations");

  let total_transport = 0;
  useEffect(() => {
    Transportations &&
      Transportations?.length > 0 &&
      Transportations?.map((item: any) => {
        total_transport += item?.Rate || 0;
      });

    formRenderProps.onChange("TotalTransportation", {
      value: total_transport + +DriverAllowance + +TotalTax || 0,
    });
  }, [
    Transportations?.map((item: any) => item?.Rate)?.join(", "),
    DriverAllowance,
    TotalTax,
  ]);

  let total_miscellaneous = 0;
  useEffect(() => {
    Miscellaneous &&
      Miscellaneous?.length > 0 &&
      Miscellaneous?.map((item: any) => {
        total_miscellaneous += item?.TotalAmount || 0;
      });

    formRenderProps.onChange("TotalMiscellaneous", {
      value: total_miscellaneous,
    });
  }, [Miscellaneous?.map((item: any) => item?.TotalAmount)?.join(", ")]);

  let total_sightseen = 0;
  useEffect(() => {
    SightSeen &&
      SightSeen?.length > 0 &&
      SightSeen?.map((item: any) => {
        total_sightseen += item?.Rate || 0;
      });

    formRenderProps.onChange("TotalSightSeen", {
      value: total_sightseen,
    });
  }, [SightSeen?.map((item: any) => item?.Rate)?.join(", ")]);

  useEffect(() => {
    formRenderProps.onChange("convertedTotalAccommodationRate", {
      value: AccommodationConversionRate * TotalAccommodationRate || 0,
    });
  }, [TotalAccommodationRate, AccommodationConversionRate]);

  useEffect(() => {
    formRenderProps.onChange("convertedTotalTransportation", {
      value: TransportaionConversionRate * TotalTransportation || 0,
    });
  }, [TotalTransportation, TransportaionConversionRate]);

  useEffect(() => {
    formRenderProps.onChange("convertedTotalMiscellaneous", {
      value: MiscellaneousConversionRate * TotalMiscellaneous || 0,
    });
  }, [TotalMiscellaneous, MiscellaneousConversionRate]);

  useEffect(() => {
    formRenderProps.onChange("convertedTotalSightSeen", {
      value: SightSeenConversionRate * TotalSightSeen || 0,
    });
  }, [TotalSightSeen, SightSeenConversionRate]);

  useEffect(() => {
    formRenderProps.onChange("TotalMarkup", {
      value:
        (AccommodationConversionRate * AccommodationMarkup || 0) +
        (TransportaionConversionRate * TransportMarkup || 0) +
        (MiscellaneousConversionRate * MiscellaneousMarkup || 0) +
        (SightSeenConversionRate * SightSeenMarkup || 0),
    });
  }, [
    AccommodationConversionRate,
    TransportaionConversionRate,
    MiscellaneousConversionRate,
    SightSeenConversionRate,
    AccommodationMarkup,
    TransportMarkup,
    MiscellaneousMarkup,
    SightSeenMarkup,
  ]);

  useEffect(() => {
    formRenderProps.onChange("TotalAmount", {
      value:
        +convertedTotalAccommodationRate +
          +convertedTotalTransportation +
          +convertedTotalMiscellaneous +
          +convertedTotalSightSeen +
          +TotalMarkup || 0,
    });
  }, [
    convertedTotalAccommodationRate,
    convertedTotalTransportation,
    convertedTotalMiscellaneous,
    convertedTotalSightSeen,
    TotalMarkup,
  ]);

  useEffect(() => {
    formRenderProps.onChange("SubTotalAmount", {
      value: +TotalAmount - +DiscountAmt || 0,
    });
  }, [DiscountAmt, TotalAmount]);

  useEffect(() => {
    formRenderProps.onChange("GstValue", {
      value: (+SubTotalAmount * +GstPer) / 100 || 0,
    });
  }, [SubTotalAmount, GstPer]);

  useEffect(() => {
    const totalAmount = +SubTotalAmount + +GstValue;

    if (Type === "INTERNATIONAL") {
      if (isTCS) {
        if (totalAmount <= (AdminSettingDetails?.TCSLimit || 0)) {
          formRenderProps.onChange("TCS", {
            value: (
              (+totalAmount * (AdminSettingDetails?.TCSUnderPer || 0)) /
              100
            )?.toFixed(2),
          });
        } else {
          const firstTCSAmount =
            ((AdminSettingDetails?.TCSLimit || 0) *
              (AdminSettingDetails?.TCSUnderPer || 0)) /
            100;
          const remainingTCSAmount =
            +totalAmount - (AdminSettingDetails?.TCSLimit || 0);
          const secondTCSAmount =
            (+remainingTCSAmount * (AdminSettingDetails?.TCSOverPer || 0)) /
            100;

          formRenderProps.onChange("TCS", {
            value: +(+firstTCSAmount + +secondTCSAmount)?.toFixed(2),
          });
        }
      } else {
        formRenderProps.onChange("TCS", {
          value: 0,
        });
      }
    } else {
      formRenderProps.onChange("TCS", {
        value: 0,
      });
    }
  }, [SubTotalAmount, GstValue, isTCS, Type]);

  useEffect(() => {
    formRenderProps.onChange("FinalAmt", {
      value: Math.round(+SubTotalAmount + +GstValue + +TCS || 0),
    });
  }, [SubTotalAmount, GstValue, TCS]);

  useEffect(() => {
    formRenderProps.onChange("RoundOff", {
      value:
        Math.round(+SubTotalAmount + +GstValue + +TCS || 0) -
        (SubTotalAmount + +GstValue + +TCS || 0),
    });
  }, [SubTotalAmount, GstValue, TCS]);

  useEffect(() => {
    const total = Accommodations.reduce((sum: number, accommodation: any) => {
      return sum + (Number(accommodation?.HotelAmount) || 0);
    }, 0);

    // Update the form field with the calculated total
    formRenderProps.onChange("TotalAccommodationRate", {
      value: total,
    });
  }, [Accommodations.map((e: any) => e?.HotelAmount)?.join("-")]);

  return null;
};
const AccomodationHotelChangeWatcher: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const dispatch = useAppDispatch();
  const Accommodations = formRenderProps.valueGetter("Accommodations");
  const isAccomodationHotelRef = useRef(true);

  const handleHotelChange = async (Hotel: number, index: number) => {
    const res = await dispatch(
      getAllActiveHotelRoomCategory({ HotelID: Hotel }),
    );
    if (res.meta?.requestStatus === "fulfilled") {
      formRenderProps.onChange(`Accommodations.${index}.roomtype_options`, {
        value: res.payload || [],
      });
    } else {
      formRenderProps.onChange(`Accommodations.${index}.roomtype_options`, {
        value: [],
      });
    }
  };

  useEffect(() => {
    if (Accommodations?.length > 0) {
      if (isAccomodationHotelRef.current) {
        Accommodations?.map((accomodation: any, index: number) => {
          const Hotel = accomodation.Hotel;
          if (Hotel) {
            handleHotelChange(+Hotel, index);
          }
        });
        isAccomodationHotelRef.current = false;
      }
    }
  }, [Accommodations]);

  return null;
};

const EditModeRateWatcher: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const QuotationID = location.state?.QuotationID;
  const Accommodations = formRenderProps.valueGetter("Accommodations");
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (QuotationID && Accommodations?.length > 0 && isFirstRun.current) {
      isFirstRun.current = false;
      Accommodations.forEach(async (accommodation: any, index: number) => {
        const { Hotel, CheckInDate, RoomTypeID, MealTypeID } = accommodation;
        const IsAutoRate = !isNaN(Number(Hotel));
        if (IsAutoRate && Hotel && CheckInDate && RoomTypeID && MealTypeID) {
          try {
            const res = await dispatch(
              getHotelSpecialRate({
                HotelID: +Hotel,
                CheckInDate: moment(CheckInDate).format("YYYY-MM-DD"),
                MealTypeID: +MealTypeID,
                RoomCategoryID: +RoomTypeID,
              }),
            );
            if (res.meta?.requestStatus === "fulfilled") {
              formRenderProps.onChange(`Accommodations.${index}.AllRates`, {
                value: res?.payload,
              });
            }
          } catch (error) {
            console.error("Failed to fetch hotel rate in edit mode:", error);
          }
        }
      });
    }
  }, [QuotationID, Accommodations]);

  return null;
};

const QuotationInformation: React.FC = () => {
  const gridRef = useRef<any>(null);
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const QuotationID = location.state?.QuotationID;
  const InquiryID = location.state?.InquiryID;

  const loading = useAppSelector((state) => state.quotation.loading);
  const contactLoading = useAppSelector((state) => state.contact.formLoading);
  const QuotationDetail = useAppSelector(
    (state) => state.quotation.QuotationDetail,
  );
  const InquiryDetails = useAppSelector(
    (state) => state.inquiry.InquiryDetails,
  );
  const LeadSourceList = useAppSelector(
    (state) => state.leadsource.LeadSourceList,
  );
  const SectorList = useAppSelector((state) => state.sector.SectorList);
  const CompanyList = useAppSelector((state) => state.company.CompanyList);
  const FoodOptionList = useAppSelector(
    (state) => state.foodOption.FoodOptionList,
  );

  const LeadDetails = useAppSelector((state) => state.lead.LeadDetails);
  const leadLoading = useAppSelector((state) => state.lead.formLoading);
  const ContactDetails = useAppSelector(
    (state) => state.contact.ContactDetails,
  );
  const AdminSettingDetails = useAppSelector(
    (state) => state.adminsetting.AdminSettingDetails,
  );

  const LeadID = location.state?.LeadID;
  const ContactID = location.state?.ContactID;

  const [formKey, setFormKey] = useState(1);
  const [initialValues, setInitialValues] = useState<any>(QuotationDetail);

  useEffect(() => {
    if (InquiryDetails?.ID) {
      const rooms = InquiryDetails?.HotelRooms || [];

      const totalAdult = rooms.reduce(
        (sum: any, room: any) => sum + (room.Adults || 0),
        0,
      );

      const totalChild = rooms.reduce(
        (sum: any, room: any) => sum + (room.Child || 0),
        0,
      );
      const totalInfant = rooms.reduce(
        (sum: any, room: any) => sum + (room.Infant || 0),
        0,
      );
      const totalRoom = rooms.length;

      const totalExtraAdult = rooms.reduce((sum: any, room: any) => {
        const extra = (room.Adults || 0) - 2;
        return sum + (extra > 0 ? extra : 0);
      }, 0);

      setInitialValues({
        ...initialValues,
        Initial: InquiryDetails?.Initial,
        FirstName: InquiryDetails?.FirstName,
        LastName: InquiryDetails?.LastName,
        MobileNo: InquiryDetails?.MobileNo,
        EmailID: InquiryDetails?.EmailID,
        ContactID: InquiryDetails?.ContactID,
        LeadID: InquiryDetails?.LeadID,
        InquiryID: InquiryDetails?.ID,
        SectorID: InquiryDetails?.DestinationID,
        PickUpPlace: InquiryDetails?.Goingfrom || InquiryDetails?.FromPlaceName,
        StartDate: InquiryDetails?.TravelDate
          ? moment(InquiryDetails?.TravelDate, "YYYY-MM-DD").toDate()
          : InquiryDetails?.DepartureDate
            ? moment(InquiryDetails?.DepartureDate, "YYYY-MM-DD").toDate()
            : "",
        EndDate: InquiryDetails?.TravelDate
          ? moment(InquiryDetails?.TravelDate, "YYYY-MM-DD")
              .add(InquiryDetails?.NoOfNights, "days")
              .toDate()
          : InquiryDetails?.ReturnDate
            ? moment(InquiryDetails?.ReturnDate, "YYYY-MM-DD").toDate()
            : "",
        PickUpDate: InquiryDetails?.TravelDate
          ? moment(InquiryDetails?.TravelDate, "YYYY-MM-DD").toDate()
          : InquiryDetails?.DepartureDate
            ? moment(InquiryDetails?.DepartureDate, "YYYY-MM-DD").toDate()
            : "",
        DropDate: InquiryDetails?.TravelDate
          ? moment(InquiryDetails?.TravelDate, "YYYY-MM-DD")
              .add(InquiryDetails?.NoOfNights, "days")
              .toDate()
          : InquiryDetails?.ReturnDate
            ? moment(InquiryDetails?.ReturnDate, "YYYY-MM-DD").toDate()
            : "",
        DropPlace: InquiryDetails?.Goingfrom || InquiryDetails?.FromPlaceName,
        TotalRoom: totalRoom,
        TotalAdult: totalAdult - totalExtraAdult,
        TotalCWB: totalChild,
        TotalCNB: totalInfant,
        ExtraAdult: totalExtraAdult,
        HotelRooms: InquiryDetails?.HotelRooms || [],
        Travelers: InquiryDetails?.Travelers,
        FoodPreferenceID: InquiryDetails?.FoodPreferenceID,
      });
    }
    return () => {
      dispatch(clearInquiryDetails());
    };
  }, [InquiryDetails]);

  useEffect(() => {
    if (LeadDetails?.ID) {
      setInitialValues({
        ...initialValues,
        Initial: LeadDetails?.Initial,
        FirstName: LeadDetails?.FirstName,
        LastName: LeadDetails?.LastName,
        MobileNo: LeadDetails?.MobileNo,
        EmailID: LeadDetails?.EmailID,
        LeadSourceID: LeadDetails?.LeadSourceID,
        ContactID: LeadDetails?.ContactID,
        LeadID: LeadDetails?.ID,
      });
    }
    return () => {
      dispatch(clearLeadDetails());
    };
  }, [LeadDetails]);

  useEffect(() => {
    if (ContactDetails?.ID) {
      setInitialValues({
        ...initialValues,
        Initial: ContactDetails?.Initial,
        FirstName: ContactDetails?.FirstName,
        LastName: ContactDetails?.LastName,
        MobileNo: ContactDetails?.MobileNo,
        EmailID: ContactDetails?.EmailID,
        LeadSourceID: ContactDetails?.LeadSourceID,
        ContactID: ContactDetails?.ID,
      });
    }
    return () => {
      dispatch(clearContactDetails());
    };
  }, [ContactDetails]);

  useEffect(() => {
    setInitialValues({
      ...initialValues,
      ...QuotationDetail,
    });
  }, [QuotationDetail]);

  useEffect(() => {
    setInitialValues({
      ...initialValues,
      GstPer: AdminSettingDetails.GST,
    });
  }, [AdminSettingDetails]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [initialValues]);

  useEffect(() => {
    dispatch(getAllActiveRoomTypes());
    dispatch(getAllActiveMealTypes());
    dispatch(getAllActiveVehicleTypes());
    dispatch(getAllActiveLeadSource());
    dispatch(getAllActiveSectors());
    dispatch(getAllActiveCompanies());
    dispatch(getAllActiveFoodOptions());
    dispatch(getAdminSettings());
    dispatch(getAllActiveCurrencies());

    if (!QuotationID && CompanyList?.length > 0) {
      const defaultCompany = CompanyList.find((company) => company?.IsDefault);
      if (defaultCompany) {
        setInitialValues((prev: any) => ({
          ...prev,
          CompanyID: defaultCompany?.ID,
        }));
      }
    }

    if (QuotationID) {
      dispatch(getQuotationByID({ ID: +QuotationID }));
    } else if (InquiryID) {
      dispatch(getInquiryByID(InquiryID));
    } else if (LeadID) {
      dispatch(getLeadByID(LeadID));
    } else if (ContactID) {
      dispatch(getContactByID(ContactID));
    }

    return () => {
      dispatch(clearQuotationInformation());
      dispatch(clearHotelRateDetails());
      dispatch(clearInquiryDetails());
    };
  }, []);

  const handleHotelSearchChange = React.useCallback(
    async (search: any, field: string, formRenderProps: FormRenderProps) => {
      const result = await dispatch(getAllHotelsForDropdown(search));
      if (result.payload) {
        formRenderProps.onChange(field, {
          value: result?.payload?.Data,
        });
      }
    },
    [dispatch],
  );

  const handleSubmit = async (values: any) => {
    let contactID = values?.ContactID ? +values?.ContactID : null;
    const insertContactPayload = {
      Initial: values?.Initial ? values?.Initial : "",
      FirstName: values?.FirstName ? values?.FirstName : "",
      LastName: values?.LastName ? values?.LastName : "",
      MobileNo: values?.MobileNo ? values?.MobileNo : "",
      CountryCode: values?.CountryCode ? values?.CountryCode : "",
      EmailID: values?.EmailID ? values?.EmailID : "",
      LeadSourceID: values?.LeadSourceID ? +values?.LeadSourceID : null,
    };

    if (!QuotationID && !InquiryID && !LeadID && !ContactID) {
      const response = await dispatch(
        insertContactFromOtherPlace(insertContactPayload),
      );

      if (
        response.meta.requestStatus === "fulfilled" &&
        response.payload?.Data?.ID
      ) {
        contactID = +response.payload.Data.ID || null;
      } else {
        return;
      }
    }

    try {
      if (QuotationID) {
        const editPayload = {
          ID: QuotationID ? +QuotationID : null,
          FirstName: values?.FirstName ? values?.FirstName : "",
          TermsNCondition: values?.TermsNCondition
            ? values?.TermsNCondition
            : "",
          LastName: values?.LastName ? values?.LastName : "",
          MobileNo: values?.MobileNo ? values?.MobileNo : "",
          CountryCode: values?.CountryCode ? values?.CountryCode : "",
          EmailID: values?.EmailID ? values?.EmailID : "",
          StartDate: values?.StartDate
            ? moment(values?.StartDate)?.format("YYYY-MM-DD")
            : "",
          EndDate: values?.EndDate
            ? moment(values?.EndDate)?.format("YYYY-MM-DD")
            : "",
          PickUpPlace: values?.PickUpPlace ? values?.PickUpPlace : "",
          PickUpDate: values?.PickUpDate
            ? moment(values?.PickUpDate)?.format("YYYY-MM-DD")
            : null,
          DropPlace: values?.DropPlace ? values?.DropPlace : "",
          DropDate: values?.DropDate
            ? moment(values?.DropDate)?.format("YYYY-MM-DD")
            : null,
          TotalRoom: values?.TotalRoom ? +values?.TotalRoom : 0,
          TotalAdult: values?.TotalAdult ? +values?.TotalAdult : 0,
          TotalCWB: values?.TotalCWB ? +values?.TotalCWB : 0,
          TotalCNB: values?.TotalCNB ? +values?.TotalCNB : 0,
          ExtraAdult: values?.ExtraAdult ? +values?.ExtraAdult : 0,
          Travelers: values?.Travelers ? +values?.Travelers : null,
          HotelRooms: values?.HotelRooms ? values?.HotelRooms : [],
          FoodPreferenceID: values?.FoodPreferenceID
            ? +values?.FoodPreferenceID
            : null,
          TotalAccommodationRate: values?.TotalAccommodationRate
            ? +values?.TotalAccommodationRate
            : 0,
          DriverAllowance: values?.DriverAllowance
            ? +values?.DriverAllowance
            : 0,
          TotalTax: values?.TotalTax ? +values?.TotalTax : 0,
          TotalTransportation: values?.TotalTransportation
            ? +values?.TotalTransportation
            : 0,
          TotalMiscellaneous: values?.TotalMiscellaneous
            ? +values?.TotalMiscellaneous
            : 0,
          TotalSightSeen: values?.TotalSightSeen ? +values?.TotalSightSeen : 0,
          AccommodationMarkup: values?.AccommodationMarkup
            ? +values?.AccommodationMarkup
            : 0,
          TransportMarkup: values?.TransportMarkup
            ? +values?.TransportMarkup
            : 0,
          MiscellaneousMarkup: values?.MiscellaneousMarkup
            ? +values?.MiscellaneousMarkup
            : 0,
          SightSeenMarkup: values?.SightSeenMarkup
            ? +values?.SightSeenMarkup
            : 0,
          TotalMarkup: values?.TotalMarkup ? +values?.TotalMarkup : 0,

          Initial: values?.Initial ? values?.Initial : "",
          LeadSourceID: values?.LeadSourceID ? +values?.LeadSourceID : null,
          SectorID: values?.SectorID ? +values?.SectorID : null,
          CompanyID: values?.CompanyID ? +values?.CompanyID : null,
          Type: values?.Type ? values?.Type : "",
          DiscountAmt: values?.DiscountAmt ? +values?.DiscountAmt : 0,
          GstPer: values?.GstPer ? +values?.GstPer : 0,
          GstValue: values?.GstValue ? +(+values?.GstValue?.toFixed(2)) : 0,
          isTCS: values?.isTCS ? values?.isTCS : false,
          IsGST: values?.IsGST ? values?.IsGST : false,
          IsDiscount: values?.IsDiscount ? values?.IsDiscount : false,
          TCS: values?.TCS ? +values?.TCS : null,
          AccommodationConversionRate: values?.AccommodationConversionRate
            ? +values?.AccommodationConversionRate
            : 0,
          TransportaionConversionRate: values?.TransportaionConversionRate
            ? +values?.TransportaionConversionRate
            : 0,
          MiscellaneousConversionRate: values?.MiscellaneousConversionRate
            ? +values?.MiscellaneousConversionRate
            : 0,
          SightSeenConversionRate: values?.SightSeenConversionRate
            ? +values?.SightSeenConversionRate
            : 0,
          AccommodationCurrencyID: values?.AccommodationCurrencyID
            ? +values?.AccommodationCurrencyID
            : null,
          TransportaionCurrencyID: values?.TransportaionCurrencyID
            ? +values?.TransportaionCurrencyID
            : null,
          MiscellaneousCurrencyID: values?.MiscellaneousCurrencyID
            ? +values?.MiscellaneousCurrencyID
            : null,
          SightSeenCurrencyID: values?.SightSeenCurrencyID
            ? +values?.SightSeenCurrencyID
            : null,
          FinalAmt: values?.FinalAmt ? +(+values?.FinalAmt?.toFixed(2)) : 0,
          Accommodations: values?.Accommodations
            ? values?.Accommodations?.map((item: any) => {
                return {
                  PlaceID: item?.PlaceID ? item?.PlaceID : null,
                  CategoryID: item?.CategoryID ? item?.CategoryID : null,
                  Hotel: item?.Hotel ? `${item?.Hotel}` : "",
                  CheckInDate: item?.CheckInDate
                    ? moment(item?.CheckInDate)?.format("YYYY-MM-DD")
                    : null,
                  CheckOutDate: item?.CheckOutDate
                    ? moment(item?.CheckOutDate)?.format("YYYY-MM-DD")
                    : null,
                  RoomTypeID: !isNaN(Number(item?.Hotel))
                    ? item?.RoomTypeID
                      ? +item?.RoomTypeID
                      : null
                    : null,
                  RoomCategoryName: isNaN(Number(item?.Hotel))
                    ? item?.RoomCategoryName
                      ? item?.RoomCategoryName
                      : ""
                    : "",
                  MealTypeID: item?.MealTypeID ? +item?.MealTypeID : null,
                  TotalRoom: item?.TotalRoom ? +item?.TotalRoom : null,
                  HotelRate: item?.HotelRate ? +item?.HotelRate : 0,
                  HotelAmount: item?.HotelAmount ? +item?.HotelAmount : 0,
                };
              })
            : [],
          Transportations: values?.Transportations
            ? values?.Transportations?.map((item: any) => {
                return {
                  VehicleTypeID: item?.VehicleTypeID
                    ? +item?.VehicleTypeID
                    : null,
                  PlaceID: item?.PlaceID ? item?.PlaceID : null,
                  FromDate: item?.FromDate
                    ? moment(item?.FromDate)?.format("YYYY-MM-DD")
                    : null,
                  ToDate: item?.ToDate
                    ? moment(item?.ToDate)?.format("YYYY-MM-DD")
                    : null,
                  Rate: item?.Rate ? +item?.Rate : 0,
                  Qty: item?.Qty ? +item?.Qty : 0,
                  Remarks: item?.Remarks ? item?.Remarks : "",
                };
              })
            : [],
          Miscellaneous: values?.Miscellaneous
            ? values?.Miscellaneous?.map((item: any) => {
                return {
                  Title: item?.Title ? item?.Title : "",
                  TotalAmount: item?.TotalAmount ? +item?.TotalAmount : 0,
                };
              })
            : [],
          SightSeen: values?.SightSeen
            ? values?.SightSeen?.map((item: any) => {
                return {
                  SightSeenID: item?.SightSeenID ? +item?.SightSeenID : null,
                  Rate: item?.Rate ? +item?.Rate : 0,
                };
              })
            : [],
        };
        const response = await dispatch(updateQuotationStep1(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          // navigate("/quotation/package/edit", {
          //   state: {
          //     QuotationID: QuotationID,
          //     mode: "create",
          //   },
          // });
          dispatch(increaseActiveStep());
        }
      } else {
        const insertPayload = {
          ContactID: contactID,
          LeadID: values?.LeadID ? +values?.LeadID : null,
          InquiryID: values?.InquiryID ? +values?.InquiryID : null,
          FirstName: values?.FirstName ? values?.FirstName : "",
          TermsNCondition: values?.TermsNCondition
            ? values?.TermsNCondition
            : "",
          LastName: values?.LastName ? values?.LastName : "",
          MobileNo: values?.MobileNo ? values?.MobileNo : "",
          CountryCode: values?.CountryCode ? values?.CountryCode : "",
          EmailID: values?.EmailID ? values?.EmailID : "",
          StartDate: values?.StartDate
            ? moment(values?.StartDate)?.format("YYYY-MM-DD")
            : null,
          EndDate: values?.EndDate
            ? moment(values?.EndDate)?.format("YYYY-MM-DD")
            : null,
          PickUpPlace: values?.PickUpPlace ? values?.PickUpPlace : "",
          PickUpDate: values?.PickUpDate
            ? moment(values?.PickUpDate)?.format("YYYY-MM-DD")
            : null,
          DropPlace: values?.DropPlace ? values?.DropPlace : "",
          DropDate: values?.DropDate
            ? moment(values?.DropDate)?.format("YYYY-MM-DD")
            : null,
          TotalRoom: values?.TotalRoom ? +values?.TotalRoom : 0,
          TotalAdult: values?.TotalAdult ? +values?.TotalAdult : 0,
          TotalCWB: values?.TotalCWB ? +values?.TotalCWB : 0,
          TotalCNB: values?.TotalCNB ? +values?.TotalCNB : 0,
          ExtraAdult: values?.ExtraAdult ? +values?.ExtraAdult : 0,
          Travelers: values?.Travelers ? +values?.Travelers : null,
          HotelRooms: values?.HotelRooms ? values?.HotelRooms : [],
          FoodPreferenceID: values?.FoodPreferenceID
            ? +values?.FoodPreferenceID
            : null,
          TotalAccommodationRate: values?.TotalAccommodationRate
            ? +values?.TotalAccommodationRate
            : 0,
          DriverAllowance: values?.DriverAllowance
            ? +values?.DriverAllowance
            : 0,
          TotalTax: values?.TotalTax ? +values?.TotalTax : 0,
          TotalTransportation: values?.TotalTransportation
            ? +values?.TotalTransportation
            : 0,
          TotalMiscellaneous: values?.TotalMiscellaneous
            ? +values?.TotalMiscellaneous
            : 0,
          TotalSightSeen: values?.TotalSightSeen ? +values?.TotalSightSeen : 0,
          AccommodationMarkup: values?.AccommodationMarkup
            ? +values?.AccommodationMarkup
            : 0,
          TransportMarkup: values?.TransportMarkup
            ? +values?.TransportMarkup
            : 0,
          MiscellaneousMarkup: values?.MiscellaneousMarkup
            ? +values?.MiscellaneousMarkup
            : 0,
          SightSeenMarkup: values?.SightSeenMarkup
            ? +values?.SightSeenMarkup
            : 0,
          TotalMarkup: values?.TotalMarkup ? +values?.TotalMarkup : 0,

          Initial: values?.Initial ? values?.Initial : "",
          LeadSourceID: values?.LeadSourceID ? +values?.LeadSourceID : null,
          SectorID: values?.SectorID ? +values?.SectorID : null,
          CompanyID: values?.CompanyID ? +values?.CompanyID : null,
          Type: values?.Type ? values?.Type : "",
          DiscountAmt: values?.DiscountAmt ? +values?.DiscountAmt : 0,
          GstPer: values?.GstPer ? +values?.GstPer : 0,
          GstValue: values?.GstValue ? +(+values?.GstValue?.toFixed(2)) : 0,
          isTCS: values?.isTCS ? values?.isTCS : false,
          IsGST: values?.IsGST ? values?.IsGST : false,
          IsDiscount: values?.IsDiscount ? values?.IsDiscount : false,
          TCS: values?.TCS ? +values?.TCS : null,
          FinalAmt: values?.FinalAmt ? +(+values?.FinalAmt?.toFixed(2)) : 0,
          AccommodationConversionRate: values?.AccommodationConversionRate
            ? +values?.AccommodationConversionRate
            : 0,
          TransportaionConversionRate: values?.TransportaionConversionRate
            ? +values?.TransportaionConversionRate
            : 0,
          MiscellaneousConversionRate: values?.MiscellaneousConversionRate
            ? +values?.MiscellaneousConversionRate
            : 0,
          SightSeenConversionRate: values?.SightSeenConversionRate
            ? +values?.SightSeenConversionRate
            : 0,
          AccommodationCurrencyID: values?.AccommodationCurrencyID
            ? +values?.AccommodationCurrencyID
            : null,
          TransportaionCurrencyID: values?.TransportaionCurrencyID
            ? +values?.TransportaionCurrencyID
            : null,
          MiscellaneousCurrencyID: values?.MiscellaneousCurrencyID
            ? +values?.MiscellaneousCurrencyID
            : null,
          SightSeenCurrencyID: values?.SightSeenCurrencyID
            ? +values?.SightSeenCurrencyID
            : null,
          Accommodations: values?.Accommodations
            ? values?.Accommodations?.map((item: any) => {
                return {
                  PlaceID: item?.PlaceID ? item?.PlaceID : null,
                  CategoryID: item?.CategoryID ? item?.CategoryID : null,
                  Hotel: item?.Hotel ? `${item?.Hotel}` : "",
                  CheckInDate: item?.CheckInDate
                    ? moment(item?.CheckInDate)?.format("YYYY-MM-DD")
                    : null,
                  CheckOutDate: item?.CheckOutDate
                    ? moment(item?.CheckOutDate)?.format("YYYY-MM-DD")
                    : null,
                  RoomTypeID: !isNaN(Number(item?.Hotel))
                    ? item?.RoomTypeID
                      ? +item?.RoomTypeID
                      : null
                    : null,
                  RoomCategoryName: isNaN(Number(item?.Hotel))
                    ? item?.RoomCategoryName
                      ? item?.RoomCategoryName
                      : ""
                    : "",
                  MealTypeID: item?.MealTypeID ? +item?.MealTypeID : null,
                  TotalRoom: item?.TotalRoom ? +item?.TotalRoom : null,
                  HotelRate: item?.HotelRate ? +item?.HotelRate : 0,
                  HotelAmount: item?.HotelAmount ? +item?.HotelAmount : 0,
                };
              })
            : [],
          Transportations: values?.Transportations
            ? values?.Transportations?.map((item: any) => {
                return {
                  VehicleTypeID: item?.VehicleTypeID
                    ? +item?.VehicleTypeID
                    : null,
                  PlaceID: item?.PlaceID ? item?.PlaceID : null,
                  FromDate: item?.FromDate
                    ? moment(item?.FromDate)?.format("YYYY-MM-DD")
                    : null,
                  ToDate: item?.ToDate
                    ? moment(item?.ToDate)?.format("YYYY-MM-DD")
                    : null,
                  Rate: item?.Rate ? +item?.Rate : 0,
                  Qty: item?.Qty ? +item?.Qty : 0,
                  Remarks: item?.Remarks ? item?.Remarks : "",
                };
              })
            : [],
          Miscellaneous: values?.Miscellaneous
            ? values?.Miscellaneous?.map((item: any) => {
                return {
                  Title: item?.Title ? item?.Title : "",
                  TotalAmount: item?.TotalAmount ? +item?.TotalAmount : 0,
                };
              })
            : [],
          SightSeen: values?.SightSeen
            ? values?.SightSeen?.map((item: any) => {
                return {
                  SightSeenID: item?.SightSeenID ? +item?.SightSeenID : null,
                  Rate: item?.Rate ? +item?.Rate : 0,
                };
              })
            : [],
        };

        const response = await dispatch(createQuotationStep1(insertPayload));
        if (
          response?.meta?.requestStatus === "fulfilled" &&
          response.payload.Data?.ID
        ) {
          navigate("/quotation/package/edit", {
            state: {
              QuotationID: response.payload.Data?.ID,
              SectorID: values?.SectorID ? +values?.SectorID : "",
              mode: "create",
            },
          });
          dispatch(increaseActiveStep());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      {(loading || contactLoading || leadLoading) && (
        <LoadingPanel gridRef={gridRef} />
      )}
      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={initialValues}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ShadowCard style={{ padding: 10 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4 className="typography-head">
                    {"Quotation Details"}
                  </Typography.h4>
                </GridLayoutItem>
                {QuotationID || InquiryID || LeadID || ContactID ? (
                  <GridLayoutItem style={{ width: "100%" }} colSpan={3}>
                    <table className="w-100">
                      <tr>
                        <th>Name</th>
                        <td>:</td>
                        <td>
                          {initialValues?.Initial} {initialValues?.FirstName}{" "}
                          {initialValues?.LastName}
                        </td>
                      </tr>
                      <tr>
                        <th>Mobile No.</th>
                        <td>:</td>
                        <td>{initialValues?.MobileNo}</td>
                        <th>Email ID</th>
                        <td>:</td>
                        <td>{initialValues?.EmailID}</td>
                      </tr>
                    </table>
                    <hr className="mb-1" />
                  </GridLayoutItem>
                ) : (
                  <>
                    <GridLayoutItem className="d-flex gap-2">
                      <Field
                        wrapperStyle={{
                          width: "100%",
                          flex: 1,
                        }}
                        id={"Initial"}
                        name={"Initial"}
                        label={"Initial"}
                        placeholder="i.e. Mr."
                        component={FormSelectionField}
                        options={NAMEPREFIX?.map((initial: any) => {
                          return {
                            value: initial?.value,
                            label: initial?.label,
                          };
                        })}
                      />
                      <Field
                        wrapperStyle={{
                          width: "100%",
                          flex: 2,
                        }}
                        name="FirstName"
                        label="First Name"
                        placeholder="i.e.John"
                        maxLength="100"
                        component={FormTextField}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="LastName"
                        label="Last Name"
                        placeholder="i.e. Smith"
                        maxLength="100"
                        component={FormTextField}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="EmailID"
                        label="Email ID"
                        astrike={true}
                        placeholder="i.e. example@gmail.com"
                        component={FormTextField}
                        validator={emailValidator}
                      />
                    </GridLayoutItem>
                    {/* <GridLayoutItem className="mb-1">
                    <Field
                      wrapperStyle={{
                        width: "100%",
                        flex: 1,
                      }}
                      name="CountryCode"
                      label="Code"
                      astrike={true}
                      placeholder="i.e. In"
                      component={CountryCodeField}
                      validator={requiredValidator}
                    />
                  </GridLayoutItem> */}
                    <GridLayoutItem className="mb-1">
                      <Field
                        // wrapperStyle={{
                        //   width: "100%",
                        //   flex: 2,
                        // }}
                        name="MobileNo"
                        label="Mobile No."
                        // type="number"
                        // max={16}
                        type="text"
                        maxLength={16}
                        onKeyPress={(e: any) => {
                          const allowedChars = /^[0-9+]$/;
                          if (!allowedChars.test(e?.key)) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="i.e. 9999999999"
                        component={FormTextField}
                        astrike={true}
                        validator={MobileNoIntValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="w-100"
                        id={"LeadSourceID"}
                        name={"LeadSourceID"}
                        label={"Lead Source"}
                        placeholder="Lead Source"
                        component={FormSelectionField}
                        astrike={true}
                        validator={requiredValidator}
                        options={LeadSourceList?.map(
                          (leadsource: ILeadSource) => {
                            return {
                              value: leadsource?.ID,
                              label: leadsource?.Source,
                            };
                          },
                        )}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem colSpan={3}>
                      <hr className="mb-1" />
                    </GridLayoutItem>
                  </>
                )}
                <GridLayoutItem>
                  <Field
                    wrapperClassName="w-100"
                    id={"SectorID"}
                    name={"SectorID"}
                    label={"Sector"}
                    placeholder="Sector"
                    component={FormSelectionField}
                    astrike={true}
                    validator={requiredValidator}
                    options={SectorList?.map((sector: ISector) => {
                      return {
                        value: sector?.ID,
                        label: sector?.SectorName,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperClassName="w-100"
                    id={"CompanyID"}
                    name={"CompanyID"}
                    label={"Company"}
                    placeholder="Company"
                    component={FormSelectionField}
                    astrike={true}
                    validator={requiredValidator}
                    options={CompanyList?.map((company: ICompany) => {
                      return {
                        value: company?.ID,
                        label: company?.CompanyName,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperClassName="w-100"
                    id={"Type"}
                    name={"Type"}
                    label={"Type"}
                    placeholder="Type"
                    component={FormSelectionField}
                    astrike={true}
                    validator={requiredValidator}
                    options={SECTORTYPE?.map((type: any) => {
                      return {
                        value: type?.value,
                        label: type?.label,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem className="d-flex gap-2">
                  <Field
                    wrapperClassName="w-100"
                    name="StartDate"
                    label="Start Date"
                    format="dd/MM/yyyy"
                    pastDate={false}
                    component={FormDatePicker}
                    astrike={true}
                    validator={requiredValidator}
                  />
                  <Field
                    wrapperClassName="w-100"
                    name="EndDate"
                    label="End Date"
                    format="dd/MM/yyyy"
                    astrike={true}
                    validator={requiredValidator}
                    minDate={moment(
                      formRenderProps.valueGetter("StartDate"),
                    ).toDate()}
                    component={FormDatePicker}
                  />
                </GridLayoutItem>
                {/* <GridLayoutItem></GridLayoutItem> */}
                <GridLayoutItem className="d-flex gap-2">
                  <Field
                    wrapperClassName="w-60"
                    name="PickUpPlace"
                    label="PickUp Place"
                    placeholder="PickUp Place"
                    component={FormTextField}
                  />
                  <Field
                    wrapperClassName="w-40"
                    name="PickUpDate"
                    label="Pickup Date"
                    pastDate={false}
                    format="dd/MM/yyyy"
                    component={FormDatePicker}
                  />
                </GridLayoutItem>
                {/* <GridLayoutItem></GridLayoutItem> */}
                <GridLayoutItem className="d-flex gap-2">
                  <Field
                    wrapperClassName="w-60"
                    name="DropPlace"
                    label="Drop Place"
                    placeholder="Drop Place"
                    component={FormTextField}
                  />
                  <Field
                    wrapperClassName="w-40"
                    name="DropDate"
                    label="Drop Date"
                    format="dd/MM/yyyy"
                    minDate={moment(
                      formRenderProps.valueGetter("PickUpDate"),
                    ).toDate()}
                    component={FormDatePicker}
                  />
                </GridLayoutItem>
                {/* <GridLayoutItem></GridLayoutItem> */}
                <GridLayoutItem className="d-flex gap-2" colSpan={2}>
                  <div
                    style={{
                      marginTop: 15,
                      display: "flex",
                      flexDirection: "column",
                      width: "20%",
                    }}
                  >
                    <Label>
                      {"Travellers"}
                      <span style={{ color: "red" }}>*</span>
                    </Label>
                    <Button
                      type="button"
                      style={{ background: "#fff" }}
                      onClick={() =>
                        dispatch(openDialog("packageQuotetravellerEditDialog"))
                      }
                    >
                      {formRenderProps.valueGetter("Travelers") || 0}
                    </Button>
                  </div>
                  <TravellerEditDialog formRenderProps={formRenderProps} />
                  <Field
                    wrapperClassName="right-aligned-field w-15"
                    name="TotalRoom"
                    label="Total Room"
                    placeholder="0"
                    min={0}
                    max={50}
                    format="n0"
                    component={FormNumericTextField}
                    validator={requiredValidator}
                    astrike={true}
                    disabled
                  />
                  {/* </GridLayoutItem>
              <GridLayoutItem> */}
                  <Field
                    wrapperClassName="right-aligned-field w-15"
                    name="TotalAdult"
                    label="Total Adult"
                    placeholder="0"
                    min={0}
                    max={50}
                    format="n0"
                    component={FormNumericTextField}
                    validator={requiredValidator}
                    astrike={true}
                    disabled
                  />
                  <Field
                    wrapperClassName="right-aligned-field w-15"
                    name="ExtraAdult"
                    label="Extra Adult"
                    placeholder="0"
                    min={0}
                    max={50}
                    format="n0"
                    component={FormNumericTextField}
                    disabled
                  />
                  {/* </GridLayoutItem>
                <GridLayoutItem className="d-flex gap-2"> */}
                  <Field
                    wrapperClassName="right-aligned-field w-15"
                    name="TotalCWB"
                    label="Total CWB"
                    placeholder="0"
                    min={0}
                    max={50}
                    format="n0"
                    component={FormNumericTextField}
                    disabled
                  />
                  {/* </GridLayoutItem>
              <GridLayoutItem> */}
                  <Field
                    wrapperClassName="right-aligned-field w-15"
                    name="TotalCNB"
                    label="Total CNB"
                    placeholder="0"
                    min={0}
                    max={50}
                    format="n0"
                    component={FormNumericTextField}
                    disabled
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperClassName="w-100"
                    id={"FoodPreferenceID"}
                    name={"FoodPreferenceID"}
                    label={"Food Preference"}
                    placeholder="Food Preference"
                    component={FormSelectionField}
                    isAddNew={true}
                    isIndirect={true}
                    drawerName="foodoptionForm"
                    options={FoodOptionList?.map((foodoption: IFoodOption) => {
                      return {
                        value: foodoption?.ID,
                        label: foodoption?.Name,
                      };
                    })}
                  />
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            {(formRenderProps?.valueGetter("Accommodations")?.length < 1 ||
              formRenderProps?.valueGetter("Transportations")?.length < 1 ||
              formRenderProps?.valueGetter("Miscellaneous")?.length < 1 ||
              formRenderProps?.valueGetter("SightSeen")?.length < 1) && (
              <ShadowCard
                style={{
                  padding: 10,
                  marginTop: 10,
                  display: "flex",
                  gap: 10,
                  alignItems: "center",
                  flexDirection: "row",
                }}
              >
                {formRenderProps?.valueGetter("Accommodations")?.length < 1 && (
                  <Button
                    fillMode={"solid"}
                    themeColor={"primary"}
                    type="button"
                    onClick={() => {
                      formRenderProps.onChange("Accommodations", {
                        value: [
                          {
                            PlaceID: "",
                            CategoryID: "",
                            Hotel: "",
                            CheckInDate: "",
                            CheckOutDate: "",
                            RoomTypeID: null,
                            MealTypeID: null,
                            TotalRoom: null,
                          },
                        ],
                      });
                    }}
                  >
                    Add Accommodation
                  </Button>
                )}
                {formRenderProps?.valueGetter("Transportations")?.length <
                  1 && (
                  <Button
                    fillMode={"solid"}
                    themeColor={"primary"}
                    type="button"
                    onClick={() => {
                      formRenderProps.onChange("Transportations", {
                        value: [
                          {
                            VehicleTypeID: null,
                            PlaceID: "",
                            FromDate: "",
                            ToDate: "",
                            Rate: null,
                          },
                        ],
                      });
                    }}
                  >
                    Add Transport
                  </Button>
                )}
                {formRenderProps?.valueGetter("Miscellaneous")?.length < 1 && (
                  <Button
                    fillMode={"solid"}
                    themeColor={"primary"}
                    type="button"
                    onClick={() => {
                      formRenderProps.onChange("Miscellaneous", {
                        value: [
                          {
                            Title: "",
                            TotalAmount: null,
                          },
                        ],
                      });
                    }}
                  >
                    Add Miscellaneous
                  </Button>
                )}
                {formRenderProps?.valueGetter("SightSeen")?.length < 1 && (
                  <Button
                    fillMode={"solid"}
                    themeColor={"primary"}
                    type="button"
                    onClick={() => {
                      formRenderProps.onChange("SightSeen", {
                        value: [
                          {
                            SightSeenID: null,
                            Rate: null,
                          },
                        ],
                      });
                    }}
                  >
                    Add SightSeen
                  </Button>
                )}
              </ShadowCard>
            )}
            {formRenderProps?.valueGetter("Accommodations")?.length > 0 && (
              <ShadowCard
                style={{
                  padding: 10,
                  marginTop: 10,
                }}
              >
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4 className="typography-head m-0">
                      {"Accommodation Details"}
                    </Typography.h4>
                  </GridLayoutItem>

                  <GridLayoutItem colSpan={3}>
                    <FieldArray
                      formRenderProps={formRenderProps}
                      component={QuotationAccomodationArray}
                      handleHotelSearchChange={handleHotelSearchChange}
                      name="Accommodations"
                    />
                  </GridLayoutItem>
                </GridLayout>
              </ShadowCard>
            )}
            {formRenderProps?.valueGetter("Transportations")?.length > 0 && (
              <ShadowCard style={{ padding: 10, marginTop: 10 }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4 className="typography-head m-0">
                      {"Transport Details"}
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={3}>
                    <FieldArray
                      formRenderProps={formRenderProps}
                      component={QuotationTransportArray}
                      name="Transportations"
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}></GridLayoutItem>
                  {formRenderProps.valueGetter("Transportations")?.length >
                    0 && (
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="calculation-label right-aligned-field"
                        wrapperStyle={{ margin: 0, width: "100%" }}
                        label={"Total"}
                        name="TotalTransportation"
                        format="n2"
                        placeholder="0"
                        component={FormNumericTextField}
                        disabled="true"
                      />
                    </GridLayoutItem>
                  )}
                </GridLayout>
              </ShadowCard>
            )}

            {formRenderProps?.valueGetter("Miscellaneous")?.length > 0 && (
              <ShadowCard style={{ padding: 10, marginTop: 10 }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  {formRenderProps?.valueGetter("Miscellaneous")?.length >
                    0 && (
                    <>
                      <GridLayoutItem colSpan={3}>
                        <Typography.h4 className="typography-head m-0">
                          {"Miscellaneous Details"}
                        </Typography.h4>
                      </GridLayoutItem>
                      <GridLayoutItem
                        colSpan={3}
                        // style={{
                        //   borderBottom: "1px dashed gray",
                        //   marginBottom: "20px",
                        // }}
                      >
                        <FieldArray
                          formRenderProps={formRenderProps}
                          component={QuotationMiscellaneousArray}
                          name="Miscellaneous"
                        />
                      </GridLayoutItem>
                    </>
                  )}
                </GridLayout>
              </ShadowCard>
            )}

            {formRenderProps?.valueGetter("SightSeen")?.length > 0 && (
              <ShadowCard style={{ padding: 10, marginTop: 10 }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4 className="typography-head m-0">
                      {"SightSeen Details"}
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={3}>
                    <FieldArray
                      formRenderProps={formRenderProps}
                      component={QuotationSightseenArray}
                      name="SightSeen"
                    />
                  </GridLayoutItem>
                </GridLayout>
              </ShadowCard>
            )}

            <ShadowCard style={{ padding: 10, marginTop: 10 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4 className="typography-head m-0">
                    {"Terms & Conditions"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem colSpan={3}>
                  <GridLayoutItem>
                    <Field
                      name="TermsNCondition"
                      component={FormRichTextField}
                      contentHeight={250}
                    />
                  </GridLayoutItem>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ padding: 10, marginTop: 10 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <div
                    style={{
                      width: "100%",
                      marginTop: "0px",
                    }}
                  >
                    <table style={{ width: "100%" }}>
                      <tr>
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            paddingBottom: 5,
                          }}
                        >
                          Total Accommodation <code>(A)</code>
                        </td>
                        <td
                          style={{
                            width: "5%",
                            textAlign: "center",
                            paddingBottom: 5,
                          }}
                        >
                          :
                        </td>
                        <td style={{ width: 200, paddingBottom: 5 }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="convertedTotalAccommodationRate"
                            format="n2"
                            placeholder="0"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            paddingBottom: 5,
                          }}
                        >
                          Total Transport <code>(B)</code>
                        </td>
                        <td
                          style={{
                            width: "5%",
                            textAlign: "center",
                            paddingBottom: 5,
                          }}
                        >
                          :
                        </td>
                        <td style={{ width: 200, paddingBottom: 5 }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="convertedTotalTransportation"
                            format="n2"
                            placeholder="0"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            paddingBottom: 5,
                          }}
                        >
                          Total Miscellaneous <code>(C)</code>
                        </td>
                        <td
                          style={{
                            width: "5%",
                            textAlign: "center",
                            paddingBottom: 5,
                          }}
                        >
                          :
                        </td>
                        <td style={{ width: 200, paddingBottom: 5 }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="convertedTotalMiscellaneous"
                            placeholder="0"
                            format="n2"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            paddingBottom: 5,
                          }}
                        >
                          Total SightSeen <code>(D)</code>
                        </td>
                        <td
                          style={{
                            width: "5%",
                            textAlign: "center",
                            paddingBottom: 5,
                          }}
                        >
                          :
                        </td>
                        <td style={{ width: 200, paddingBottom: 5 }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="convertedTotalSightSeen"
                            placeholder="0"
                            format="n2"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            paddingBottom: 5,
                          }}
                        >
                          Total Markup <code>(E)</code>
                        </td>
                        <td
                          style={{
                            width: "5%",
                            textAlign: "center",
                            paddingBottom: 5,
                          }}
                        >
                          :
                        </td>
                        <td style={{ width: 200, paddingBottom: 5 }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="TotalMarkup"
                            placeholder="0"
                            format="n2"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr
                        style={{
                          borderTop: "1px solid gainsboro",
                        }}
                      >
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            padding: "5px 0",
                          }}
                        >
                          Total <code>(F) = (A + B + C + D + E)</code>
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}></td>
                        <td style={{ width: 200, padding: "5px 0 0" }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="TotalAmount"
                            placeholder="0"
                            format="n2"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr
                        style={{
                          borderBottom: "1px solid gainsboro",
                        }}
                      >
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            padding: "10px 0",
                          }}
                        >
                          <Field
                            name="IsDiscount"
                            label="is Discount Apply"
                            component={FormCheckbox}
                            wrapperStyle={{
                              fontWeight: 600,
                              margin: 0,
                              display: "inline-block",
                            }}
                            style={{ border: "1px solid darkgray" }}
                            onChange={() => {
                              formRenderProps.onChange("DiscountAmt", {
                                value: 0,
                              });
                            }}
                          />{" "}
                          <code>(G)</code>
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}>:</td>
                        <td style={{ width: 200 }}>
                          <Field
                            wrapperClassName="disabled-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="DiscountAmt"
                            placeholder="0"
                            format="n2"
                            min={0}
                            max={formRenderProps.valueGetter("TotalAmount")}
                            component={FormNumericTextField}
                            disabled={
                              !formRenderProps.valueGetter("IsDiscount")
                            }
                          />
                        </td>
                      </tr>
                      <tr
                        style={{
                          borderTop: "1px solid gainsboro",
                        }}
                      >
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            padding: "10px 0",
                          }}
                        >
                          Total <code>(H) = (F - G)</code>
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}>:</td>
                        <td style={{ width: 200 }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="SubTotalAmount"
                            placeholder="0"
                            format="n2"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr
                        style={{
                          borderTop: "1px solid gainsboro",
                        }}
                      >
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            padding: "5px 0",
                          }}
                        >
                          <div className="d-flex gap-1 align-items-center justify-content-end">
                            <Field
                              name="IsGST"
                              label="is GST Apply"
                              component={FormCheckbox}
                              wrapperStyle={{
                                fontWeight: 600,
                                margin: 0,
                                display: "inline-block",
                              }}
                              style={{ border: "1px solid darkgray" }}
                              onChange={() => {
                                formRenderProps.onChange("GstPer", {
                                  value: 0,
                                });
                              }}
                            />{" "}
                            <code>(I)</code>{" "}
                            {formRenderProps.valueGetter("IsGST") && (
                              <>
                                <Field
                                  wrapperClassName="calculation-label right-aligned-field"
                                  wrapperStyle={{ margin: 0, maxWidth: 100 }}
                                  name="GstPer"
                                  placeholder="0"
                                  format="n2"
                                  min={0}
                                  max={100}
                                  component={FormNumericTextField}
                                />
                                (%)
                              </>
                            )}
                          </div>
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}>:</td>
                        <td style={{ width: 200, padding: "5px 0" }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="GstValue"
                            placeholder="0"
                            format="n2"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            padding: "5px 0",
                          }}
                        >
                          <Field
                            name="isTCS"
                            label="is TCS Apply"
                            component={FormCheckbox}
                            wrapperStyle={{
                              fontWeight: 600,
                              margin: 0,
                              display: "inline-block",
                            }}
                            style={{ border: "1px solid darkgray" }}
                          />{" "}
                          <code>(J)</code>
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}>:</td>
                        <td style={{ width: 200, padding: "0 0 5px" }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="TCS"
                            placeholder="0"
                            format="n2"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            padding: "5px 0",
                          }}
                        >
                          Round Off <code>(K)</code>
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}>:</td>
                        <td style={{ width: 200, padding: "0 0 5px" }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="RoundOff"
                            placeholder="0"
                            format="n2"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr
                        style={{
                          borderTop: "1px solid gainsboro",
                          borderBottom: "1px solid gainsboro",
                        }}
                      >
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            padding: "10px 0",
                          }}
                        >
                          Grand Total <code>(L) = (H + I + J)</code>
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}>:</td>
                        <td style={{ width: 200 }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="FinalAmt"
                            placeholder="0"
                            format="n2"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                    </table>
                  </div>
                </GridLayoutItem>
                <GridLayoutItem
                  colSpan={3}
                  style={{
                    textAlign: "end",
                    marginTop: 20,
                    width: "100%",
                  }}
                >
                  <ButtonWithLoading
                    label={QuotationID ? "Update" : "Save"}
                    type="submit"
                    disabled={
                      !formRenderProps.allowSubmit || loading || contactLoading
                    }
                    loading={loading || contactLoading}
                  />
                  <RippleButton
                    fillMode="outline"
                    themeColor="primary"
                    style={{ marginLeft: 10 }}
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </RippleButton>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>

            <SectorChangeWatcher formRenderProps={formRenderProps} />
            <TotalChangeWatcher formRenderProps={formRenderProps} />
            <AccomodationHotelChangeWatcher formRenderProps={formRenderProps} />
            <EditModeRateWatcher formRenderProps={formRenderProps} />
          </FormElement>
        )}
      />
    </>
  );
};

interface TravellerEditDialogProps {
  formRenderProps: FormRenderProps;
}

const TravellerEditDialog: React.FC<TravellerEditDialogProps> = ({
  formRenderProps,
}) => {
  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  return (
    <>
      {dialogName === "packageQuotetravellerEditDialog" && (
        <AppDialog>
          <GridLayout style={{ maxWidth: 600 }}>
            <FieldArray
              formRenderProps={formRenderProps}
              component={TravellerQuotationRoomArray}
              name="HotelRooms"
            />
          </GridLayout>
        </AppDialog>
      )}
    </>
  );
};

export default QuotationInformation;
